var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChooseGroupArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.895,
    height: 6.406,
    viewBox: "0 0 12.895 6.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4956",
    "data-name": "Path 4956",
    d: "M5.468,0,2.574,3.2l2.895,3.2H2.894L0,3.2,2.894,0Z",
    transform: "translate(7.426 0)",
    fill: "#24b8c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4957",
    "data-name": "Path 4957",
    d: "M46.021,0,43.127,3.2l2.895,3.2H43.448L40.553,3.2,43.448,0Z",
    transform: "translate(-36.84 0)",
    fill: "#24b8c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4958",
    "data-name": "Path 4958",
    d: "M86.574,0,83.68,3.2l2.895,3.2H84L81.107,3.2,84,0Z",
    transform: "translate(-81.106 0)",
    fill: "#24b8c0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseGroupArrow);
export default __webpack_public_path__ + "static/media/choose-group-arrow.973e785c50eab3e156b91b75178a15fa.svg";
export { ForwardRef as ReactComponent };